var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_6923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.875 8.8125C2.875 10.3872 3.50056 11.8974 4.61405 13.0109C5.72755 14.1244 7.23778 14.75 8.8125 14.75C10.3872 14.75 11.8974 14.1244 13.0109 13.0109C14.1244 11.8974 14.75 10.3872 14.75 8.8125C14.75 7.23778 14.1244 5.72755 13.0109 4.61405C11.8974 3.50056 10.3872 2.875 8.8125 2.875C7.23778 2.875 5.72755 3.50056 4.61405 4.61405C3.50056 5.72755 2.875 7.23778 2.875 8.8125Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8605 18.6521L13.1667 13.9583",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_6923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2b0051791945af6f5b8713d7aa4c69a3.svg";
export { ForwardRef as ReactComponent };